import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "new22",
  "use": "new22-usage",
  "viewBox": "0 0 15.97 15.97",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.97 15.97\" id=\"new22\"><defs><style>#new22 .cls-1{fill:none}#new22 .cls-2{fill:#fff}</style></defs><title>编组 24备份 10</title><g id=\"new22_图层_2\" data-name=\"图层 2\"><g id=\"new22_图层_1-2\" data-name=\"图层 1\"><g id=\"new22_编组_24备份_10\" data-name=\"编组 24备份 10\"><g id=\"new22_编组\"><path id=\"new22_Clip_2\" data-name=\"Clip 2\" class=\"cls-1\" d=\"M0 0h16v16H0z\" /><path id=\"new22_Fill_1-2\" data-name=\"Fill 1-2\" class=\"cls-2\" d=\"M14.45 15.93H1.58a.92.92 0 0 1 0-1.84h12.87a.92.92 0 1 1 0 1.84zm-.31-3.06H1.89V6.13a6.13 6.13 0 1 1 12.25 0v6.73zM8 1.84a4.29 4.29 0 0 0-4.27 4.29v.06a.91.91 0 0 0 .92.81.92.92 0 0 0 .9-.9A2.44 2.44 0 0 1 8 3.68a.92.92 0 0 0 0-1.84z\" /></g></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/new22.svg
// module id = 2Ibg
// module chunks = 6